import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { AI_INDEX_NOTE, formatOdds, formatPercent } from './utils';

const formatEvValue = (value) => {
  if (value === undefined || value === null || Number.isNaN(Number(value))) return '-';
  return Number(value).toFixed(2);
};

const formatEdgeValue = (value) => {
  if (value === undefined || value === null || Number.isNaN(Number(value))) return '-';
  const num = Number(value);
  return `${num >= 0 ? '+' : ''}${num.toFixed(2)}`;
};

function EvBetPanel({
  bets,
  eyebrow = 'VALUE BETS',
  // bet.ev も馬別の expectedValue と同じ「確率 × オッズ」（build_exotic_bets.py の ev = prob * odds）。
  // 同じ画面で片方だけ「期待値」と呼ぶと大小の意味が取り違えられるため AI指数 に統一する（#72）。
  title = 'AI指数の高い買い目',
  emptyText = 'AI指数が基準を超えた買い目はありません',
  // 単体利用時に注記が落ちないよう既定は true。RaceDetailPage だけが false にする。
  showNote = true,
}) {
  return (
    <Box className="race-detail-panel">
      <Typography className="race-detail-section-eyebrow">{eyebrow}</Typography>
      <Typography className="race-detail-section-title">{title}</Typography>

      {!bets?.length ? (
        <Typography sx={{ mt: 2.5, color: 'rgba(203, 229, 245, 0.72)' }}>{emptyText}</Typography>
      ) : (
        <TableContainer className="race-detail-table-shell" sx={{ mt: 2.5 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>買い目</TableCell>
                <TableCell align="right">オッズ</TableCell>
                <TableCell align="right">推定確率</TableCell>
                <TableCell align="right">AI指数</TableCell>
                <TableCell align="right">エッジ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bets.map((bet) => (
                <TableRow key={`${bet.combo}-${bet.rank || 0}`} hover>
                  <TableCell>{bet.combo || '-'}</TableCell>
                  <TableCell align="right">{formatOdds(bet.odds)}</TableCell>
                  <TableCell align="right">{formatPercent(bet.pHatPct, 1)}</TableCell>
                  <TableCell align="right">{formatEvValue(bet.ev)}</TableCell>
                  <TableCell align="right">{formatEdgeValue(bet.edge)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {showNote && (
        <Typography className="race-detail-table-subtext" sx={{ mt: 1.5, display: 'block' }}>
          ※ {AI_INDEX_NOTE}
        </Typography>
      )}
    </Box>
  );
}

export default EvBetPanel;
